// Ian - Adds a lean mobile read more toggle to Envy collection descriptions.
(function () {
  if (!window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) return;

  function init() {
    var description = document.querySelector('.collection-header__description');
    if (!description || description.querySelector('.ian-collection-read-more')) return;

    var textItem = description.querySelector('.collection-header__text-item');
    if (!textItem) return;

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'ian-collection-read-more';
    button.setAttribute('aria-expanded', 'false');
    button.textContent = 'Read more';

    description.appendChild(button);

    button.addEventListener('click', function () {
      var expanded = description.classList.toggle('is-expanded');
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      button.textContent = expanded ? 'Read less' : 'Read more';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();